import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import Icon from '../../components/icon/Icon'
import {
  PageContainer,
  Card,
  Emoji,
  Code,
  Heading,
  Subheading,
  Actions,
  PrimaryAction,
  SecondaryAction,
} from './styled'
import { pickNotFoundCopy } from './helpers'

/**
 * 404 surface for unknown routes. Picks a random copy variant on each
 * mount so refreshes feel different. Renders unauthenticated — no
 * provider guards required — so any deeplink goes here cleanly.
 *
 * @returns {JSX.Element}
 */
const NotFoundPage = (): JSX.Element => {
  const navigate = useNavigate()
  const copy = useMemo(() => pickNotFoundCopy(Date.now()), [])

  const handleHome = (): void => {
    navigate('/')
  }

  const handleSavedListings = (): void => {
    navigate('/saved-listings')
  }

  return (
    <PageContainer>
      <Card
        initial={{ opacity: 0, y: 16, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1, transition: { duration: 0.4 } }}
      >
        <Emoji aria-hidden="true">
          <Icon icon={copy.icon} label="Not found" />
        </Emoji>
        <Code>404 · Page not found</Code>
        <Heading>{copy.heading}</Heading>
        <Subheading>{copy.subheading}</Subheading>
        <Actions>
          <PrimaryAction type="button" onClick={handleHome}>
            Take me home
          </PrimaryAction>
          <SecondaryAction type="button" onClick={handleSavedListings}>
            View saved listings
          </SecondaryAction>
        </Actions>
      </Card>
    </PageContainer>
  )
}

export default NotFoundPage
